import {
  GET_AGENDA_REQUEST,
  GET_AGENDA_SUCCESS,
  SET_EVENTS_AGENDA,
  RESET_EVENTOS,
  SET_COMPLETADO_EVENTO,
  DELETE_EVENT,
  CREATE_EVENT,
  UPDATE_EVENT,
} from '../../actions/constants/agenda/agenda.constants';

const initialState = {
  loading: false,
  listado: [],
  total: 0,
  page: 1,
  start: 0,
  limit: 9999,
  tipoListado: 'listado_basico',
  events: [],
  tipoTarea: '',
};

export default function agendaReducer(state = initialState, { type, payload }) {
  switch (type) {
    case GET_AGENDA_REQUEST: {
      return {
        ...state, loading: true,
      };
    }

    case GET_AGENDA_SUCCESS: {
      const {
        datos, total, page, start, limit,
      } = payload;
      return {
        ...state, listado: [...datos], total, loading: false, page, start, limit,
      };
    }

    case SET_EVENTS_AGENDA: {
      const { events } = payload;
      return {
        ...state, events,
      };
    }

    case RESET_EVENTOS: {
      const { events } = payload;
      return {
        ...state, events,
      };
    }

    case SET_COMPLETADO_EVENTO:
    case DELETE_EVENT:
    case CREATE_EVENT:
    case UPDATE_EVENT:
    {
      const { id } = payload;
      return {
        ...state, id,
      };
    }

    default:
      return state;
  }
}
